import React from "react";
import InsightsReactPlugin from "./AppInsights";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import {AppInsightsProviderProps} from "./type"

const AppInsightsProvider: React.FC<AppInsightsProviderProps> = ({ children }) => {
    return (
        <AppInsightsContext.Provider value={InsightsReactPlugin}>
            {children}
        </AppInsightsContext.Provider>
    );
};

export default AppInsightsProvider;